"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _reactSpinners = require("react-spinners");

var _bestApps = _interopRequireDefault(require("../../assets/logo/best-apps.png"));

var _baseball = _interopRequireDefault(require("../../assets/baseball.png"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var StyledLoader = (0, _styledComponents["default"])(_reactSpinners.FadeLoader).withConfig({
  displayName: "Loader__StyledLoader",
  componentId: "sc-1rrrm4v-0"
})(["margin:0 auto;opacity:1;"]);

var BaseballFixed = _styledComponents["default"].img.withConfig({
  displayName: "Loader__BaseballFixed",
  componentId: "sc-1rrrm4v-1"
})(["&&&{position:absolute;margin-left:2px;height:45px;margin-top:-52px;-webkit-animation:baseballfixed 2s linear infinite;-moz-animation:baseballfixed 2s linear infinite;animation:baseballfixed 2s linear infinite;@-moz-keyframes baseballfixed{100%{-moz-transform:rotate(360deg);}}@-webkit-keyframes baseballfixed{100%{-webkit-transform:rotate(360deg);}}@keyframes baseballfixed{100%{-webkit-transform:rotate(360deg);transform:rotate(360deg);}}}"]);

var Baseball = _styledComponents["default"].img.withConfig({
  displayName: "Loader__Baseball",
  componentId: "sc-1rrrm4v-2"
})(["&&&{height:75px;-webkit-animation:baseball 2s linear infinite;-moz-animation:baseball 2s linear infinite;animation:baseball 2s linear infinite;@-moz-keyframes baseball{100%{-moz-transform:rotate(360deg);}}@-webkit-keyframes baseball{100%{-webkit-transform:rotate(360deg);}}@keyframes baseball{100%{-webkit-transform:rotate(360deg);transform:rotate(360deg);}}}"]);

var MlbLogo = _styledComponents["default"].img.withConfig({
  displayName: "Loader__MlbLogo",
  componentId: "sc-1rrrm4v-3"
})(["&&&{width:", ";height:auto;-webkit-animation:mlblogo 1.75s linear infinite;-moz-animation:mlblogo 1.75s linear infinite;animation:mlblogo 1.75s linear infinite;@-moz-keyframes mlblogo{100%{-moz-transform:rotateY(-360deg);}}@-webkit-keyframes mlblogo{100%{-webkit-transform:rotateY(-360deg);}}@keyframes mlblogo{100%{-webkit-transform:rotateY(-360deg);transform:rotateY(-360deg);}}}"], function (props) {
  return props.width;
});

var Loader = function Loader(_ref) {
  var type = _ref.type;
  var Theme = (0, _react.useContext)(_styledComponents.ThemeContext);

  var getLoader = function getLoader() {
    switch (type) {
      case 3:
        return _react["default"].createElement(Baseball, {
          src: _baseball["default"]
        });

      case 2:
        return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(StyledLoader, {
          sizeUnit: "px",
          size: 50,
          color: Theme["mlb-blue"]
        }), _react["default"].createElement(BaseballFixed, {
          src: _baseball["default"]
        }));

      case 1:
      default:
        return _react["default"].createElement(MlbLogo, {
          src: _bestApps["default"],
          width: "120px"
        });
    }
  };

  return getLoader();
};

Loader.defaultProps = {
  type: 1
};
Loader.propTypes = {
  type: _propTypes["default"].number
};
var _default = Loader;
exports["default"] = _default;